import request from '@/utils/request';
import { stringify } from 'qs';
import { loginCompany, loginOrg } from '@/utils/LoginContext';

export async function query(payload) {
  return request(`/iwms-wms/wms/onlinealcntctypepickerconfig/page`,{
    method: 'POST',
    body: payload,
  });
}
export async function saveOrModify(payload) {
    return request(`/iwms-wms/wms/onlinealcntctypepickerconfig`, {
      method: 'POST',
      body: payload
    });
  }

  export async function remove(payload) {
    return request(`/iwms-wms/wms/onlinealcntctypepickerconfig/remove?${stringify(payload)}`, {
      method: 'DELETE'}
    );
}